import { schema } from 'normalizr';

const possibleAnswerSchema = new schema.Entity('$$possible_answers');
export const questionSchema = new schema.Entity('$$questions', {
  possible_answers: [possibleAnswerSchema],
});
